import React, { useContext } from "react";
import { LanguageContext } from "../LanguageProvider";

// Importar las banderas (asegúrate de tener las imágenes en tu carpeta de assets)
import esFlag from "../assets/flags/es.png";
import enFlag from "../assets/flags/en.png";
import { useIntl } from "react-intl";

const LanguageSwitcher: React.FC = () => {
  const context = useContext(LanguageContext);
  const { formatMessage } = useIntl();

  if (!context) {
    throw new Error("LanguageSwitcher must be used within a LanguageProvider");
  }

  const { changeLanguage } = context;

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <button 
        onClick={() => changeLanguage("en")} 
        style={{ display: "flex", alignItems: "center", border: "none", background: "transparent", cursor: "pointer" }}
      >
        <img 
          src={enFlag} 
          alt="English" 
          style={{ width: "20px", height: "15px", marginRight: "8px" }}
        />
        {formatMessage({ id: "lenguage.en" })}
      </button>
      <button 
        onClick={() => changeLanguage("es")} 
        style={{ display: "flex", alignItems: "center", border: "none", background: "transparent", cursor: "pointer" }}
      >
        <img 
          src={esFlag} 
          alt="Español" 
          style={{ width: "20px", height: "15px", marginRight: "8px" }}
        />
        {formatMessage({ id: "lenguage.es" })}
      </button>
    </div>
  );
};

export default LanguageSwitcher;
